// Remove 'filter-drawer-open' from body when mobile filter close button is clicked
// Place this in your theme's custom.js or theme.js

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-filter-nav__panel .mobile-filter-nav__close')) {
      document.body.classList.remove('filter-drawer-open');
    }
  });
});
